export default __webpack_public_path__ + "static/media/gb-wls.a154b143.svg";